import { Alert, Loader } from '@piggytechng/component-library';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ApiResponse } from '../../../types';
import { httpClient } from '../../../api/http';

const CustomerFreezeAccount = () => {
  const params = useParams();
  const navigate = useNavigate();

  const freezeToken = params.token as string;

  React.useEffect(() => {
    if (freezeToken) {
      fetchEncryptionKey();
    } else {
      Alert.error('Token is missing');
      navigate('/login');
    }
  }, [freezeToken]);

  const fetchEncryptionKey = async () => {
    try {
      // Encoded so a crafted route segment cannot traverse to another path on that host.
      const url = `https://core-dot-piggybankservice.ey.r.appspot.com/v5/${encodeURIComponent(freezeToken)}`;
      const response: ApiResponse = await httpClient.get(url);
      const { status, data, message } = response.data;

      if (status) {
        Alert.success(message || 'Account frozen successfully');
      } else {
        Alert.error(data.message || 'An error occurred while freezing the account');
      }
    } catch (error) {
      Alert.error('An error occurred while freezing the account');
      console.log(error);
    } finally {
      navigate('/login');
    }
  };
  return (
    <div className="page-loader">
      <Loader color="#0F60D6" />
    </div>
  );
};

export default CustomerFreezeAccount;
